import { REDUX_STORE } from '@funnels/constants';
import {
  ClearRelatedPartyErrorAction,
  CreateRelatedPartyAction,
  CreateRelatedPartyFailAction,
  CreateRelatedPartySuccessAction,
  DeleteRelatedPartyAction,
  DeleteRelatedPartyFailAction,
  DeleteRelatedPartySuccessAction,
  FetchRelatedPartyAction,
  FetchRelatedPartyFailAction,
  FetchRelatedPartySuccessAction,
  RelatedParty,
  ServerRelatedPartyFetch,
  UpdateRelatedPartyAction,
  UpdateRelatedPartyFailAction,
  UpdateRelatedPartySuccessAction,
  UpsertRelatedPartyAction,
  UpsertRelatedPartyFailAction,
  UpsertRelatedPartySuccessAction,
} from '@funnels/types';

export function clearRelatedPartyError(): ClearRelatedPartyErrorAction {
  return { type: REDUX_STORE.RELATED_PARTY.ACTION_TYPES.CLEAR_RELATED_PARTY_ERROR };
}

export function createRelatedParty(applicationId: string, relatedParty: RelatedParty): CreateRelatedPartyAction {
  return {
    type: REDUX_STORE.RELATED_PARTY.ACTION_TYPES.CREATE_RELATED_PARTY,
    applicationId,
    relatedParty,
  };
}

export function createRelatedPartyFail(
  clientId: string,
  message: string = 'Unknown error'
): CreateRelatedPartyFailAction {
  return { type: REDUX_STORE.RELATED_PARTY.ACTION_TYPES.CREATE_RELATED_PARTY_FAIL, clientId, message };
}

export function createRelatedPartySuccess(clientId: string, id: string): CreateRelatedPartySuccessAction {
  return { type: REDUX_STORE.RELATED_PARTY.ACTION_TYPES.CREATE_RELATED_PARTY_SUCCESS, clientId, id };
}

export function deleteRelatedParty(applicationId: string, clientId: string): DeleteRelatedPartyAction {
  return {
    type: REDUX_STORE.RELATED_PARTY.ACTION_TYPES.DELETE_RELATED_PARTY,
    applicationId,
    clientId,
  };
}

export function deleteRelatedPartyFail(
  clientId: string,
  message: string = 'Unknown error'
): DeleteRelatedPartyFailAction {
  return { type: REDUX_STORE.RELATED_PARTY.ACTION_TYPES.DELETE_RELATED_PARTY_FAIL, clientId, message };
}

export function deleteRelatedPartySuccess(): DeleteRelatedPartySuccessAction {
  return { type: REDUX_STORE.RELATED_PARTY.ACTION_TYPES.DELETE_RELATED_PARTY_SUCCESS };
}

export function fetchRelatedParty(applicationId: string): FetchRelatedPartyAction {
  return { type: REDUX_STORE.RELATED_PARTY.ACTION_TYPES.FETCH_RELATED_PARTY, applicationId };
}

export function fetchRelatedPartyFail(message: string = 'Unknown error'): FetchRelatedPartyFailAction {
  return { type: REDUX_STORE.RELATED_PARTY.ACTION_TYPES.FETCH_RELATED_PARTY_FAIL, message };
}

export function fetchRelatedPartySuccess(relatedParties: ServerRelatedPartyFetch[]): FetchRelatedPartySuccessAction {
  return {
    type: REDUX_STORE.RELATED_PARTY.ACTION_TYPES.FETCH_RELATED_PARTY_SUCCESS,
    relatedParties,
  };
}

export function updateRelatedParty(applicationId: string, relatedParty: RelatedParty): UpdateRelatedPartyAction {
  return {
    type: REDUX_STORE.RELATED_PARTY.ACTION_TYPES.UPDATE_RELATED_PARTY,
    applicationId,
    relatedParty,
  };
}

export function updateRelatedPartyFail(
  clientId: string,
  message: string = 'Unknown error'
): UpdateRelatedPartyFailAction {
  return { type: REDUX_STORE.RELATED_PARTY.ACTION_TYPES.UPDATE_RELATED_PARTY_FAIL, clientId, message };
}

export function updateRelatedPartySuccess(): UpdateRelatedPartySuccessAction {
  return { type: REDUX_STORE.RELATED_PARTY.ACTION_TYPES.UPDATE_RELATED_PARTY_SUCCESS };
}

export function upsertRelatedParty(applicationId: string, relatedParties: RelatedParty[]): UpsertRelatedPartyAction {
  return {
    type: REDUX_STORE.RELATED_PARTY.ACTION_TYPES.UPSERT_RELATED_PARTY,
    applicationId,
    relatedParties,
  };
}

export function upsertRelatedPartyFail(message: string): UpsertRelatedPartyFailAction {
  return { type: REDUX_STORE.RELATED_PARTY.ACTION_TYPES.UPSERT_RELATED_PARTY_FAIL, message };
}

export function upsertRelatedPartySuccess(): UpsertRelatedPartySuccessAction {
  return { type: REDUX_STORE.RELATED_PARTY.ACTION_TYPES.UPSERT_RELATED_PARTY_SUCCESS };
}
